import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Space, TextArea } from '@pitchero/react-ui';
import { Trans, withTranslation } from '../../lib/i18n';
import AvailabilityFormOption from './availability-form-option';

const AvailabilityForm = ({ status: initialStatus, note: initialNote, onSubmit, t }) => {
  const [status, setStatus] = useState(initialStatus);
  const [note, setNote] = useState(initialNote);

  return (
    <>
      <div style={{ flex: 1 }}>
        <Space bottom="medium">
          <Grid
            className="grid-availability-form"
            columns="18px 1fr 16px"
            rowGap="medium"
            alignItems="center"
          >
            <AvailabilityFormOption
              isChecked={status === 'available'}
              onClick={() => setStatus('available')}
              statusValue="available"
            />
            <AvailabilityFormOption
              isChecked={status === 'unavailable'}
              onClick={() => setStatus('unavailable')}
              statusValue="unavailable"
            />
            <AvailabilityFormOption
              isChecked={status === 'not_sure'}
              onClick={() => setStatus('not_sure')}
              statusValue="not_sure"
            />
          </Grid>
        </Space>

        <Space bottom="medium">
          <TextArea
            input={{ value: note || '', placeholder: t('common:availability_note_placeholder') }}
            onChange={(event) => setNote(event.target.value)}
          />
        </Space>
      </div>

      <Button theme="primary" onClick={() => onSubmit(status, note)}>
        <Trans>Save</Trans>
      </Button>
    </>
  );
};

AvailabilityForm.defaultProps = {
  note: null,
  status: null,
};

AvailabilityForm.propTypes = {
  note: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  status: PropTypes.oneOf(['available', 'not_set', 'not_sure', 'unavailable']),
  t: PropTypes.func.isRequired,
};

export default withTranslation(['common'])(AvailabilityForm);
